import React from 'react';
import { Button, Form, Input, Select } from 'antd';

//mobx
import { useStore } from '@/store';
import { observer } from 'mobx-react-lite';
import { set, runInAction, toJS } from 'mobx';

import 'moment/locale/zh-cn';


const App = () => {
    //mobx
    const { DeviceStore } = useStore()
    // 取消按钮
    const [form] = Form.useForm();
    const { Option } = Select
    //日期

    //表单提交
    const onFinish = async (values) => {
        // if (values.GreenHouseName) {
        //     let a = values.GreenHouseName.split(',')
        //     values.GreenHouseId = a[0]
        //     values.GreenHouseName = a[1]
        // }
        await DeviceStore.getAddDevice(values)
    };

    //表单取消
    const onReset = () => {
        form.resetFields();
        runInAction(() => {
            set(DeviceStore, { isAshow: false })
        })
    };


   
    return (
        <>
            <Form
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 14,
                }}
                form={form}
                onFinish={onFinish}
            >
                <Form.Item
                    label="设备名称"
                    name="DevName"
                    rules={[
                        {
                            required: true,
                            message: '请选择设备名称',
                        },
                    ]}
                >
                <Input placeholder="" />
                    {/* <Select
                        placeholder="请选择设备名称"
                    >
                        {
                            DeviceStore.selectdata && (
                                toJS(DeviceStore.selectdata).map((item) => {
                                    return <Option value={item.value} key={item.value}>{item.label}</Option>
                                })
                            )
                        }
                    </Select> */}

                </Form.Item>
                <Form.Item
                    label="设备编号"
                    name="DevCode"
                    rules={[
                        {
                            required: true,
                            message: '请输入设备编号',
                        },
                    ]}
                >
                    <Input placeholder="" />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 6 }}>
                    <Button type="primary" htmlType="submit">
                        提交
                    </Button>
                    <Button htmlType="button" onClick={onReset} style={{ marginLeft: '15px' }}>
                        取消
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}
export default observer(App)